import React from 'react';
import { values, map, keys, equals, find } from 'ramda';
import { StepsCircle } from '@prima-afp/prima-ui-elements/dist/core';
import { MainTitle } from '../../shared/components';
import { PAGES_MAIN_TITLE } from '../constants';
import { ROUTES } from '../router';

const formatInputData = ({ title }) => ({ title, current: undefined, active: undefined });

const withStepsHOC = (Component) => {

  const stepOrder = {
    0: {
      path: ROUTES.BENEFICIARIES_REGISTER,
      title: 'Beneficiarios',
    },
    1: {
      path: ROUTES.MINIMUM_PENSION_ESTIMATE,
      title: 'Pensión mínima',
    },
  }

  const formattedSteps = map(formatInputData, values(stepOrder));

  return (props) => {

    const { location } = props;
    const { pathname } = location;

    const currentStep = find(order => equals(stepOrder[order].path, pathname), keys(stepOrder));

    const setStepStatus = (step, index) => {
      const stepDirection = Math.sign(index - currentStep);
      const current = stepDirection === 0;
      const active = stepDirection < 0;
      return { ...step, current, active };
    }

    const steps = formattedSteps.map(setStepStatus);

    return (
      <>
        <MainTitle fontSize={'24px'}>{ PAGES_MAIN_TITLE }</MainTitle>
        <StepsCircle steps={steps} theme={'green'} center />
        <Component {...props} />
      </>
    );
  };
};

export default withStepsHOC;